<h4 style="text-align: center;">
    INFORMATIONS SUR LA PARCELLE 
</h4>
<form #observationForm="ngForm" name="observationForm" >




    <mat-divider></mat-divider> <br />

    <div style="float: right;">
        <button style="color: black;" class="btn btn-default" mat-dialog-close>
            Annuler
        </button> &nbsp;
    </div>

</form>